<template>
  <div id="d3-antes-6">
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="D3 antes 6 meses"
            description="Crianças com menos de 6 meses de idade que receberam 3ª dose de Vip ou Penta"
            url="/imunizacao/divergencias-vacinas"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="filter-select">
            <vue-select
              :options="equipes"
              label="no_esf_eap"
              placeholder="Equipes"
              @input="onChangeEquipe"
            >
              <template slot="option" slot-scope="option">
                {{ option.no_esf_eap }} -
                {{ option.ine_esf_eap }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="info-table">
            <div class="select-situacao info-table-item">
              <vue-select
                :options="situacaoOptions"
                label="label"
                placeholder="Registro e-SUS"
                v-model="situacao"
                @input="handleSituacao($event)"
                :clearable="true"
              >
                <template slot="option" slot-scope="option">
                  {{ option.label }}
                </template>
                <div slot="no-options">Não há opções correspondentes</div>
              </vue-select>
            </div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="d3-antes-6-meses"
              >
              </download-files>
            </div>
          </div>
          <tabela-cadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'

export default {
  name: 'D3Antes6',
  components: {
    SectionTitle,
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  mixins: [utils],
  data() {
    return {
      equipe: null,
      cadastrosOriginais: [],
      cadastros: [],
      loading: false,
      situacaoOptions: [
        { label: 'Últimos 6 meses', value: 'ultimos-6-meses' },
        { label: 'Últimos 12 meses', value: 'ultimos-12-meses' },
        { label: 'Mais de 12 meses', value: 'mais-de-12-meses' },
      ],
      situacao: { label: 'Últimos 6 meses', value: 'ultimos-6-meses' },
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },

    equipes() {
      return this.$store.state.equipesV2 || []
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Filtra os dados
     *
     * @param {Object|null} situacao
     * @param {Object} equipe
     */
    filtros(situacao, equipe) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = this.cadastrosOriginais

      if (equipe != null) {
        data = this.cadastrosOriginais.filter((item) => {
          return item.cnes == equipe.nu_cnes
        })
      }
      if (situacao != null) {
        data = this.filterBySituacao(data, situacao.value)
      }
      this.cadastros = data
    },

    /**
     * Filtra por situação
     *
     * @param {Array} data
     * @param {Object} event
     *
     * @returns {Array}
     */
    handleSituacao(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }

      this.situacao = event

      this.filtros(this.situacao, this.equipe)
    },

    /**
     * Filtra por situação
     * @param {array} data
     * @param {string} situacao
     * @returns {array}
     */
    filterBySituacao(data, situacao) {
      let filtrado = data.filter((item) => {
        const meses_aplicacao = Number(item.meses_aplicacao)
        if (situacao === 'ultimos-6-meses') {
          return meses_aplicacao <= 6
        }
        if (situacao === 'ultimos-12-meses') {
          return meses_aplicacao <= 12
        }
        if (situacao === 'mais-de-12-meses') {
          return meses_aplicacao > 12
        } else {
          return item
        }
      })

      return filtrado
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loading = true
        this.equipe = event
        this.cadastros = []

        this.filtros(this.situacao, this.equipe)

        this.loading = false
      } else {
        this.equipe = null
        this.situacao = null
        this.cadastros = this.cadastrosOriginais
      }
    },

    /**
     * Buscar dados
     */
    async buscarDadosIniciais() {
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/vacinas-d3-antes-6-meses/' + this.$store.state.cod_ibge
        )
        this.cadastros = response.data
        this.cadastrosOriginais = response.data
        this.filtros(this.situacao.value, null)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(this.displayedCadastros, this.equipe)
    },

    /**
     * Inicializa os dados
     */
    async init() {
      await this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style scoped></style>
